<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="500px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <ChooseForm ref="chooseForm" @confirm="(e) => $emit('confirm', e)" />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="$refs.chooseForm.confirm()"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import ChooseForm from './index.vue'
export default {
  components: { ChooseForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
